export default {
    filterNames: {
        employment_types: 'Employment types',
        education_level: 'Degrees',
        education_fields: 'Fields',
        job_category: 'Fields',
        address: 'Locations',
        sector: 'Sectors',
        exclude_school_id: 'Exclude',
        languages: 'Languages',
    },

    excludeSchoolIds: {
        '-1': 'Shared posts',
        unknownSchoolId: 'EFMD School Partner',
    },

    educationLevels: {
        BACHELORS_OR_EQUIVALENT: 'Bachelors',
        MASTERS_OR_EQUIVALENT: 'Masters',
        DOCTORAL_OR_EQUIVALENT: 'PHD',
        MBA_OR_EQUIVALENT: 'MBA',
        DBA_OR_EQUIVALENT: 'DBA',
    },
    employmentTypes: {
        FULL_TIME: 'Full time',
        INTERN: 'Internship',
        TEMPORARY: 'Part time',
        PART_TIME: 'Part time',
        CREDIT_GIVING_INTERNSHIP: 'Credit giving internship',
    },
    startDate: 'Start',
    jobCategories: {
        ACCOUNTING_AND_FINANCE: 'Accounting and finance',
        ADMINISTRATIVE_AND_OFFICE: 'Administrative and office',
        ADVERTISING_AND_MARKETING: 'Advertising and marketing',
        ART_FASHION_AND_DESIGN: 'Art fashion and design',
        BUSINESS_OPERATIONS: 'Business operations',
        COMPUTER_AND_IT: 'Computer and IT',
        CUSTOMER_SERVICE: 'Customer service',
        EDUCATION: 'Education',
        HEALTHCARE: 'Healthcare',
        HUMAN_RESOURCES: 'Human resources',
        INSTALLATION_MAINTENANCE_AND_REPAIR: 'Installation maintenance and repair',
        LEGAL: 'Legal',
        MANAGEMENT: 'Management',
        MANUFACTURING_AND_WAREHOUSE: 'Manufacturing and warehouse',
        MEDIA_COMMUNICATIONS_AND_WRITING: 'Media communications and writing',
        OIL_GAS_AND_MINING: 'Energy',
        PROTECTIVE_SERVICES: 'Protective services',
        REAL_ESTATE: 'Real estate',
        SALES_AND_RETAIL: 'Sales and retail',
        SCIENCE_AND_ENGINEERING: 'Science and engineering',
        SOCIAL_SERVICES_AND_NON_PROFIT: 'Social services and non profit',
        TRANSPORTATION_AND_LOGISTICS: 'Transportation and logistics',
    },
    educationFields: {
        'Business Management Engineering': 'Business Management Engineering',
        Geology: 'Geology',
        'Sustainable Energy': 'Sustainable Energy',
        'Renewable Energy Engineering': 'Renewable Energy Engineering',
        'Architectural Engineering': 'Architectural Engineering',
        'Structural Engineering': 'Structural Engineering',
        'Energy Engineering': 'Energy Engineering',
        'Executive Leadership': 'Executive Leadership',
        'Electrical Engineering': 'Electrical Engineering',
        'Corporate Governance': 'Corporate Governance',
        'Automotive Engineering': 'Automotive Engineering',
        'Maintenance and Operations': 'Maintenance and Operations',
        'Information Technology': 'Information Technology',
        Physics: 'Physics',
        'General Engineering': 'General Engineering',
        Chemistry: 'Chemistry',
        'Petroleum Engineering': 'Petroleum Engineering',
        'Management Science': 'Management Science',
        'Computer Science Engineering': 'Computer Science Engineering',
        'Software Engineering': 'Software Engineering',
        'Environmental Engineering': 'Environmental Engineering',
        'Business law': 'Business law',
        Psychology: 'Psychology',
        Media: 'Media',
        Mathematics: 'Mathematics',
        'Social Media': 'Social Media',
        'Natural Sciences': 'Natural Sciences',
        Law: 'Law',
        Biology: 'Biology',
        'Biomedical Engineering': 'Biomedical Engineering',
        'Forensic Accounting': 'Forensic Accounting',
        'Retail Management': 'Retail Management',
        'Event Management': 'Event Management',
        Science: 'Science',
        Engineering: 'Engineering',
        'Quality Management': 'Quality Management',
        'Master in Management (MiM)': 'Master in Management (MiM)',
        'Civil Engineering': 'Civil Engineering',
        'Transport Management': 'Transport Management',
        'BioMolecular Engineering': 'BioMolecular Engineering',
        'Safety Engineering': 'Safety Engineering',
        'Master in Business Administration (MBA)': 'Master in Business Administration (MBA)',
        'Industrial Engineering': 'Industrial Engineering',
        Marketing: 'Marketing',
        'International trade': 'International trade',
        'International Business': 'International Business',
        'Public Administration': 'Public Administration',
        'Business Administration': 'Business Administration',
        'Corporate Communication': 'Corporate Communication',
        'Corporate Social Responsibility': 'Corporate Social Responsibility',
        'E-commerce': 'E-commerce',
        Consultancy: 'Consultancy',
        Auditing: 'Auditing',
        Banking: 'Banking',
        'Business Intelligence & Analytics': 'Business Intelligence & Analytics',
        Commerce: 'Commerce',
        Agribusiness: 'Agribusiness',
        Accounting: 'Accounting',
        Finance: 'Finance',
        'Management, Organisation & Leadership': 'Management, Organisation & Leadership',
        Economics: 'Economics',
        Sales: 'Sales',
        'Geo Engineering': 'Geo Engineering',
        'Marine Engineering': 'Marine Engineering',
        'Climate Engineering': 'Climate Engineering',
        'Real Estate': 'Real Estate',
        Entrepreneurship: 'Entrepreneurship',
        Taxation: 'Taxation',
        'Finance & Investment': 'Finance & Investment',
        'Executive MBA': 'Executive MBA',
        Sustainability: 'Sustainability',
        'Risk Management': 'Risk Management',
        'Project Management': 'Project Management',
        'Human Resource Management': 'Human Resource Management',
        'Mechanical Engineering': 'Mechanical Engineering',
        'Strategic Management': 'Strategic Management',
        'Technology Management': 'Technology Management',
        'Supply Chain Management & Logistics': 'Supply Chain Management & Logistics',
        'Innovation Management': 'Innovation Management',
    },
    sectors: {
        Consulting: 'Consulting',
        'Consumer Goods': 'Consumer Goods',
        Engineering: 'Engineering',
        'Financial Services / Banking': 'Financial Services / Banking',
        'Goverment / Public Administration / Non Profit':
            'Goverment / Public Administration / Non Profit',
        'International Trade & Development': 'International Trade & Development',
        Manufacturing: 'Manufacturing',
        'Media / Entertainment': 'Media / Entertainment',
        'Petroleum / Energy': 'Petroleum / Energy',
        'Pharma / Healthcare / Biotech': 'Pharma / Healthcare / Biotech',
        'Real Estate / Construction / Infrastructure':
            'Real Estate / Construction / Infrastructure',
        'Technology (IT) / Telecom': 'Technology (IT) / Telecom',
        'Transportations & Logistics': 'Transportations & Logistics',
        Other: 'Other',
    },
    countries: {
        'China (Hong Kong SAR)': 'Hong Kong',
        'Costa Rica': 'Costa Rica',
        'Europe & Sub-Saharan Africa': 'Europe & Sub-Saharan Africa',
        'Hong Kong': 'Hong Kong',
        'Korea, South': 'South Korea',
        'New Zealand': 'New Zealand',
        'Papua-Ny Guinea': 'Papua New Guinea',
        'Puerto Rico': 'Puerto Rico',
        'Saudi Arabia': 'Saudi Arabia',
        'South Africa': 'South Africa',
        'South Korea': 'South Korea',
        'Sri Lanka': 'Sri Lanka',
        'Taiwan (Province of China)': 'Taiwan',
        'The Seychell Islands': 'Seychelles',
        'United Arab Emirates': 'United Arab Emirates',
        'United Kingdom': 'United Kingdom',
        'Ivory Coast': 'Ivory Coast',
        Afghanistan: 'Afghanistan',
        Albania: 'Albania',
        Algeria: 'Algeria',
        Angola: 'Angola',
        Argentina: 'Argentina',
        Armenia: 'Armenia',
        Australia: 'Australia',
        Austria: 'Austria',
        Azerbaijan: 'Azerbaijan',
        Bahamas: 'Bahamas',
        Bahrain: 'Bahrain',
        Bangladesh: 'Bangladesh',
        Belarus: 'Belarus',
        Belgium: 'Belgium',
        Benin: 'Benin',
        Botswana: 'Botswana',
        Brazil: 'Brazil',
        Bulgaria: 'Bulgaria',
        'Burkina Faso': 'Burkina Faso',
        Burundi: 'Burundi',
        'Cabo Verde': 'Cabo Verde',
        Cambod: 'Cambod',
        Cambodia: 'Cambodia',
        Canada: 'Canada',
        Chile: 'Chile',
        China: 'China',
        Colombia: 'Colombia',
        Congo: 'Congo',
        Croatia: 'Croatia',
        Cyprus: 'Cyprus',
        Czechia: 'Czechia',
        Denmark: 'Denmark',
        Ecuador: 'Ecuador',
        Egypt: 'Egypt',
        'El Salvador': 'El Salvador',
        Estonia: 'Estonia',
        Ethiopia: 'Ethiopia',
        Fiji: 'Fiji',
        Finland: 'Finland',
        France: 'France',
        Gabon: 'Gabon',
        Gambia: 'Gambia',
        Germany: 'Germany',
        Ghana: 'Ghana',
        Greece: 'Greece',
        Guatemala: 'Guatemala',
        Guinea: 'Guinea',
        Guernsey: 'Guernsey',
        Hungary: 'Hungary',
        Iceland: 'Iceland',
        India: 'India',
        Indonesia: 'Indonesia',
        Iraq: 'Iraq',
        Ireland: 'Ireland',
        Israel: 'Israel',
        Italy: 'Italy',
        Japan: 'Japan',
        Jersey: 'Jersey',
        Jordan: 'Jordan',
        Kazakhstan: 'Kazakhstan',
        Kenya: 'Kenya',
        Kuwait: 'Kuwait',
        Laos: 'Laos',
        Latvia: 'Latvia',
        Lebanon: 'Lebanon',
        Liechtenstein: 'Liechtenstein',
        Lithuania: 'Lithuania',
        Luxembourg: 'Luxembourg',
        Macao: 'Macao',
        Malaysia: 'Malaysia',
        Mali: 'Mali',
        Malta: 'Malta',
        Martinique: 'Martinique',
        Mauritania: 'Mauritania',
        Mayotte: 'Mayotte',
        Mauritius: 'Mauritius',
        Mexico: 'Mexico',
        'Micronesia (Federated States of)': 'Micronesia (Federated States of)',
        Monaco: 'Monaco',
        Mongolia: 'Mongolia',
        Morocco: 'Morocco',
        Mozambique: 'Mozambique',
        Myanmar: 'Myanmar',
        Namibia: 'Namibia',
        Nepal: 'Nepal',
        Netherlands: 'Netherlands',
        Niger: 'Niger',
        Nigeria: 'Nigeria',
        'North Macedonia': 'North Macedonia',
        Norway: 'Norway',
        Oman: 'Oman',
        Pakistan: 'Pakistan',
        Panama: 'Panama',
        Paraguay: 'Paraguay',
        Peru: 'Peru',
        Philippines: 'Philippines',
        Poland: 'Poland',
        Portugal: 'Portugal',
        Qatar: 'Qatar',
        Romania: 'Romania',
        Russia: 'Russia',
        Rwanda: 'Rwanda',
        Senegal: 'Senegal',
        Serbia: 'Serbia',
        Singapore: 'Singapore',
        Slovakia: 'Slovakia',
        Slovenia: 'Slovenia',
        Spain: 'Spain',
        Sudan: 'Sudan',
        Swaziland: 'Swaziland',
        Sweden: 'Sweden',
        Switzerland: 'Switzerland',
        Syria: 'Syria',
        Taiwan: 'Taiwan',
        Tanzania: 'Tanzania',
        Thailand: 'Thailand',
        Tonga: 'Tonga',
        'Timor-Leste': 'Timor-Leste',
        'Trinidad and Tobago': 'Trinidad and Tobago',
        Tunisia: 'Tunisia',
        Turkey: 'Turkey',
        Ukraina: 'Ukraine',
        Ukraine: 'Ukraine',
        USA: 'USA',
        Uzbekistan: 'Uzbekistan',
        Vanuatu: 'Vanuatu',
        Venezuela: 'Venezuela',
        Vietnam: 'Vietnam',
        Yemen: 'Yemen',
        Zambia: 'Zambia',
        Zimbabwe: 'Zimbabwe',
    },
    languages: {
        Aceh: 'Aceh',
        Afrikaans: 'Afrikaans',
        Albanian: 'Albanian',
        Amharic: 'Amharic',
        Arabic: 'Arabic',
        Arakanese: 'Arakanese',
        Armenian: 'Armenian',
        Azeri: 'Azeri',
        Badini: 'Badini',
        Basque: 'Basque',
        Belarusian: 'Belarusian',
        Bengali: 'Bengali',
        Berber: 'Berber',
        Bosnian: 'Bosnian',
        Bulgarian: 'Bulgarian',
        Burmese: 'Burmese',
        Cantonese: 'Cantonese',
        Catalan: 'Catalan',
        Cebuano: 'Cebuano',
        Chechen: 'Chechen',
        Chin: 'Chin',
        Chinese: 'Chinese',
        Croatian: 'Croatian',
        Czech: 'Czech',
        Danish: 'Danish',
        Dari: 'Dari',
        Dutch: 'Dutch',
        English: 'English',
        Estonian: 'Estonian',
        Faroese: 'Faroese',
        Filipino: 'Filipino',
        Finnish: 'Finnish',
        French: 'French',
        German: 'German',
        Greek: 'Greek',
        Greenlandic: 'Greenlandic',
        Hausa: 'Hausa',
        Hebrew: 'Hebrew',
        Hindi: 'Hindi',
        Hungarian: 'Hungarian',
        Icelandic: 'Icelandic',
        Indonesian: 'Indonesian',
        Italian: 'Italian',
        Japanese: 'Japanese',
        Kazakh: 'Kazakh',
        Kinyarwanda: 'Kinyarwanda',
        Kirundi: 'Kirundi',
        Korean: 'Korean',
        Kurdish: 'Kurdish',
        Kurmanji: 'Kurmanji',
        Kven: 'Kven',
        Latin: 'Latin',
        Latvian: 'Latvian',
        Lingala: 'Lingala',
        Lithuanian: 'Lithuanian',
        Macedonian: 'Macedonian',
        Malagasy: 'Malagasy',
        Malaysian: 'Malaysian',
        Mandarin: 'Mandarin',
        Mongolian: 'Mongolian',
        Nepali: 'Nepali',
        Norwegian: 'Norwegian',
        Oromo: 'Oromo',
        Other: 'Other',
        Panjabi: 'Panjabi',
        Pashto: 'Pashto',
        Persian: 'Persian',
        Polish: 'Polish',
        Portuguese: 'Portuguese',
        Punjabi: 'Punjabi',
        Romanes: 'Romanes',
        Romani: 'Romani',
        Romanian: 'Romanian',
        Russian: 'Russian',
        Sami: 'Sami',
        Serbian: 'Serbian',
        Sign_language: 'Sign language',
        Slovak: 'Slovak',
        Slovene: 'Slovene',
        Somali: 'Somali',
        Sorani: 'Sorani',
        Spanish: 'Spanish',
        Swahili: 'Swahili',
        Swedish: 'Swedish',
        Tagalog: 'Tagalog',
        Tamil: 'Tamil',
        Thai: 'Thai',
        Tigrinya: 'Tigrinya',
        Turkish: 'Turkish',
        Ukrainian: 'Ukrainian',
        Urdu: 'Urdu',
        Uyghur: 'Uyghur',
        Vietnamese: 'Vietnamese',
        Wolof: 'Wolof',
    },
};
